export enum EstimateState {
  ERROR,
  ESTIMATE,
  SUBSCRIPTION
}
